module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/226e066693229820e85b3c9f4f14480d.png";